"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3335],{

/***/ 53335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M4.3 2h15.4C21.522 2 23 3.478 23 5.3v11c0 1.822-1.478 3.3-3.3 3.3v1.1a1.1 1.1 0 0 1-2.2 0v-1.1h-11v1.1a1.1 1.1 0 0 1-2.2 0v-1.1A3.301 3.301 0 0 1 1 16.3v-11C1 3.478 2.478 2 4.3 2zm15.4 15.4a1.1 1.1 0 0 0 1.1-1.1v-11a1.1 1.1 0 0 0-1.1-1.1H4.3a1.1 1.1 0 0 0-1.1 1.1v11a1.1 1.1 0 0 0 1.1 1.1h15.4zm-8.8-6.6c0-2.429 1.971-4.4 4.4-4.4 2.429 0 4.4 1.971 4.4 4.4 0 2.429-1.971 4.4-4.4 4.4a4.402 4.402 0 0 1-4.4-4.4zm2.191.017c0 1.215.995 2.192 2.209 2.183a2.21 2.21 0 0 0 1.892-1.091H16.4a1.1 1.1 0 0 1 0-2.2h.792a2.187 2.187 0 0 0-1.918-1.1c-1.215 0-2.183.994-2.183 2.208zM7.6 7.5H6.5a1.1 1.1 0 0 0 0 2.2h1.1a1.1 1.1 0 0 0 0-2.2zm-1.1 4.4h1.1a1.1 1.1 0 0 1 0 2.2H6.5a1.1 1.1 0 0 1 0-2.2z"
}), "SafeBox"));


/***/ })

}]);